var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-main',{staticClass:"index-main"},[_c('router-view',{staticClass:"router-view",staticStyle:{"height":"auto","background":"transparent"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }